import qs from "qs";
import { HttpService } from "../../constant/Api";
import { Log, logType } from "../../constant/helper";

export const API = "v1";

export const getCategories = (
  type = "consulting_and_reviewing_documents",
  params = { country: "IR" }
) => {
  return HttpService.get(`${API}/session/category/root/${type}`, {
    params,
  });
};

export const getSubCategories = (id) => {
  if (!id) {
    Log("id is not found", logType.error);
    return false;
  }
  return HttpService.get(`${API}/session/category/children/${id}`);
};

export const findLawyerService = (catId) => {
  if (!catId) {
    Log("catId is not found", logType.error);
    return false;
  }
  return HttpService.post(`${API}/session`, { catId });
};

export const rateToConsultionService = (
  params = { sessionId: "", comment: "", rate: 0 }
) => {
  if (!params.sessionId || !params.sessionId.length) {
    Log("sessionId is not found", logType.error);
    return false;
  }

  params = qs.stringify(params);

  return HttpService.post(`${API}/rate/add?${params}`);
};
